import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import PseRepository from '@/domain/repositories/PseRepository';
import PseDataRepository from '@/data/repositories/PseDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    const {
      selectPeriod,
      ddjjSusaludDoc,
      ddjjInsuranceValidity,
      attachedFiles,
      isAutomated
    } = action;
    yield put({ type: Types.REGISTER_PSE_REQUEST });

    XCheckpointManager.registerStart('Validacion de seguro register');

    const { academic } = yield select((state: any) => state?.profile?.data);

    const pseRepository: PseRepository = new PseDataRepository();
    const pseResponse = yield call(
      pseRepository.registerInsuranceValidation,
      selectPeriod,
      academic?.campus ?? '',
      ddjjSusaludDoc,
      ddjjInsuranceValidity,
      attachedFiles,
      isAutomated
    );

    if (!pseResponse) {
      throw new Error(
        'No se obtuvieron datos al momento de registrar la validación del seguro.'
      );
    }
    yield put({
      type: Types.REGISTER_PSE_SUCCESS,
      data: pseResponse
    });
    XCheckpointManager.registerEnd('Validacion de seguro register');
  } catch (error: any) {
    yield put({
      type: Types.REGISTER_PSE_FAILURE,
      error:
        error?.message ||
        'Ocurrió un error al momento de registrar la validación del seguro.'
    });
    XCheckpointManager.registerEnd('Validacion de seguro register');
  }
}
